import React, { useContext, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, Button, Typography } from '@material-ui/core';
import { firebaseAuth } from '../provider/AuthProvider';
import { rememberDestination } from '../routing/navigation';
import { authError } from '../firebase/authSession';

export default function AppHeader({ children }) {
  const { currentUser, loading, handleSignout } = useContext(firebaseAuth);
  const history = useHistory();
  const location = useLocation();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const signOut = async () => {
    setBusy(true);
    setError('');
    try { await handleSignout(); history.replace('/'); }
    catch (failure) { setBusy(false); setError(authError(failure)); }
  };
  return <AppBar position="fixed" style={{ background: '#111', color: '#fff' }}>
    <Toolbar style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
      <Button component={Link} to="/" style={{ background: '#ffcf02', color: '#111', fontWeight: 700 }}>21IFM</Button>
      <Typography style={{ flexGrow: 1, fontWeight: 600 }}>Illustrated Options</Typography>
      <Button color="inherit" component={Link} to="/chapters">Chapters</Button>
      <Button color="inherit" component={Link} to="/consulting">Consulting</Button>
      {loading ? <Typography role="status">Checking session…</Typography> : currentUser ? <>
        <Button color="inherit" component={Link} to="/account">Account</Button>
        <Button color="inherit" disabled={busy} onClick={signOut}>{busy ? 'Signing out…' : 'Sign out'}</Button>
      </> : <Button color="inherit" component={Link} to="/signin" onClick={() => rememberDestination(location)}>Sign in</Button>}
      {error && <Typography role="alert" style={{ width: '100%', color: '#ffb4ab' }}>{error}</Typography>}
    </Toolbar>{children}
  </AppBar>;
}
